import { NextPage } from 'next'

import { Heading1, Intro } from 'src/components/atoms/Typography'
import {
  FullWidthContainer,
  FullWidthContainerBackgroundColor
} from 'src/components/layouts/Container'
import { Page } from 'src/components/layouts/Page'
import { EditProject } from 'src/components/organisms/EditProject'

import { withAuthRequired } from 'src/utils/auth'

const CreateProjectPage: NextPage = () => {
  return (
    <Page title='Create Project' showBreadcrumbs={false}>
      <FullWidthContainer
        width='fixed-narrow'
        backgroundColor={FullWidthContainerBackgroundColor.linen}
      >
        <div className='text-center mb-10'>
          <Heading1>Create or add a new project</Heading1>
          <Intro>Tell us about your planting project.</Intro>
        </div>

        <EditProject projectPhotosInS3={[]} isAdmin={false} />
      </FullWidthContainer>
    </Page>
  )
}

export default withAuthRequired(CreateProjectPage)
